import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from './Footer';
import { PrimaryCTA, TrustSignals } from './Shared';
type LegalLayoutProps = {
  title: string;
  updated: string;
  children: React.ReactNode;
};
export function LegalLayout({
  title,
  updated,
  children
}: LegalLayoutProps) {
  return <div className="container" data-id="element-71">
      <header className="legal-header" data-id="element-72">
        <Link to="/" className="legal-back" aria-label="Volver al inicio" data-id="element-73">
          <span aria-hidden="true" data-id="element-74">←</span> Volver
        </Link>
        <Link to="/" className="legal-wordmark" data-id="element-75">
          ARMONY
        </Link>
      </header>

      <main className="legal-page" data-id="element-76">
        <h1 className="legal-h1" data-id="element-77">{title}</h1>
        <p className="legal-updated" data-id="element-78">Última actualización · {updated}</p>

        <p className="legal-draft-note" data-id="element-79">
          Borrador editorial. Pendiente de revisión legal antes de publicación.
        </p>

        <div className="legal-body" data-id="element-80">{children}</div>

        <section className="legal-close" data-id="element-81">
          <p className="legal-close-line" data-id="element-82">
            Esta página existe para tu tranquilidad. Cuando estés lista para el
            método:
          </p>
          <PrimaryCTA ctaId="legal" data-id="element-83" />
          <TrustSignals data-id="element-84" />
        </section>
      </main>

      <Footer data-id="element-85" />
    </div>;
}